<template>
	<v-container>
		<v-row justify="center" v-if="person">
			<v-col
				sm="10"
				md="9"
				lg="8"
				xl="6"
				v-if="hasIdCompany && adminProfile && adminProfile.company"
				class="mt-16"
			>
				<v-alert prominent type="info">
					<v-row align="center">
						<v-col class="grow">
							Actualmente perteneces a {{ adminProfile.company }}
							<div class="caption">*Solo puedes unirte a un equipo</div>
						</v-col>
						<v-col class="shrink">
							<v-btn small light @click="unsubscribe" :loading="loading">
								Salir del equipo
							</v-btn>
						</v-col>
					</v-row>
				</v-alert>
			</v-col>
			<v-col sm="10" md="9" lg="8" xl="6" v-if="person.request.length">
				<div v-for="(item, i) in person.request" :key="i">
					<requests :item="item" :index="i" />
				</div>
			</v-col>
			<v-col sm="10" md="9" lg="8" xl="6" v-if="!hasRequest && !hasIdCompany">
				<v-alert type="info">
					*Ahora no tienes solicitudes para unirte a un equipo
				</v-alert>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
	components: {
		Requests: () => import('@/components/persons/Requests'),
	},
	data() {
		return {
			loading: false,
		};
	},
	computed: {
		hasRequest() {
			return (
				Boolean(this.person) &&
				Array.isArray(this.person.request) &&
				this.person.request.length
			);
		},
		hasIdCompany() {
			return this.person && this.person.idCompany;
		},
		...mapGetters({
			person: 'Person/person',
			adminProfile: 'User/profileUser',
		}),
	},
	methods: {
		async unsubscribe() {
			this.loading = true;
			confirm('Estas seguro de que quieres salirte del equipo?') &&
				(await this.unlinkInvite(this.person._id));
			this.loading = false;
		},
		...mapActions({
			unlinkInvite: 'Person/unlinkInvite',
		}),
	},
};
</script>
